import { DateRage } from "components/HeroSearchForm/type";

const converSelectedDateToString = ([startDate, endDate]: DateRage) => {
  const dateString =
    (startDate?.toLocaleDateString("fr-FR", {
      month: "short",
      day: "2-digit",
      year: "numeric",
    }) || "") +
    (endDate
      ? " - " +
        endDate?.toLocaleDateString("fr-FR", {
          month: "short",
          day: "2-digit",
          year: "numeric",
        })
      : "");
  return dateString;
};

export default converSelectedDateToString;
